import {useQueries} from '@tanstack/react-query'
import {getGrowthBookData} from '@/services/growthBook'
import gb from '@/utils/growthbookUtils'
import {useEffect} from 'react'

export const useGrowthBookFeatureFlags = () => {
  const [results] = useQueries({queries: [{queryKey: ['GROWTHBOOK_CONFIG'], queryFn: getGrowthBookData}]})
  const features = results.data?.features
  useEffect(() => {
    if (features && Object.keys(features).length !== 0) {
      gb?.setFeatures(features)
    }
  }, [features])
  return {growthbook: gb}
}
